import { useCallback, useState } from 'react';
import { ICurriculoFullDTO } from '../../../models/happy-code-api.model';
import { PageableResponse } from '../../../models/response.model';
import { useCurriculoService } from '../../../services/curriculo-service';
import useAddPredicateOnQueryParam from './use-add-predicate-on-query-param.hook';
import { useGlobalContext } from '../../../context/GlobalContext';
import { useHandlePageChangeHook } from '../../../hooks/use-handle-page-change.hook';
import { useUnidadeService } from '../../../services/unidade.service';

export default function useFindCurriculo() {
  const curriculoService = useCurriculoService();
  const { addPredicateOnQueryParam } = useAddPredicateOnQueryParam();
  const onPageChange = useHandlePageChangeHook();
  const { unidade, usuario, setIsGlobalLoading } = useGlobalContext();
  const unidadeService = useUnidadeService();

  const [curriculosData, setCurriculosData] =
    useState<PageableResponse<ICurriculoFullDTO>>();

  const findTipoUnidadeByUnidadeId = useCallback(async (): Promise<number> => {
    return unidadeService.findById({ id: unidade?.id }).then(({ data }) => {
      return data.tipoUnidade.id;
    });
  }, [unidade]);

  const findCurriculo = useCallback(
    async (page?: number): Promise<void> => {
      if (!usuario.acessoB2c) return;

      setIsGlobalLoading(true);
      const predicate = addPredicateOnQueryParam(page);

      const tipoUnidadeId = await findTipoUnidadeByUnidadeId();

      await curriculoService
        .findCustom(unidade?.id, tipoUnidadeId, predicate)
        .then(({ data }) => setCurriculosData(data))
        .finally(() => setIsGlobalLoading(false));
    },
    [addPredicateOnQueryParam],
  );

  return {
    curriculos: {
      data: curriculosData,
      getData: findCurriculo,
      onPageChange: onPageChange(findCurriculo),
    },
  };
}
